//PROJECTS IMAGE
// import image from "./image.png";
import {
  movie,
  reactTextUtils,
  dashboard,
  todo,
  reactblogapp,
} from "./projectImg";

//SKILLS SVG
import {
  react,
  typescript,
  javascript,
  nodejs,
  mongodb,
  tailwindcss,
  wordpress,
  bootstrap,
  express,
  java,
  git,
  cpp,
  ads,
  figma,
  mysql,
  python,
  linux,
} from "./skillSvg";

//SOCIALS SVG
import { github, linkedin, hackerrank, leetcode } from "./socials";

export const certifications = [
  {
    title: "SDE Intern (6 Months) - TraxSmart",
    link: "https://drive.google.com/file/d/1E0_-RdI7iBCZC3yGzQpyXFuYUqonN9GY/view",
  },
  {
    title: "Software Engineer Role - Hackerrank",
    link: "https://www.hackerrank.com/certificates/f8c8fcb078f0",
  },
  {
    title: "JavaScript (Intermediate) Certificate - Hackerrank",
    link: "https://www.hackerrank.com/certificates/b6ea59a1dcce",
  },
  {
    title: "Node.js (Intermediate) Certificate - Hackerrank",
    link: "https://www.hackerrank.com/certificates/1e9a00d6b1da",
  },
  {
    title: "Java (Basic) Certificate - Hackerrank",
    link: "https://www.hackerrank.com/certificates/7edac49d27bb",
  },
];

export const socials = [
  // {
  //   name: "chakrabortyk21offc@gmail.com",
  //   link: "https://mail.google.com/mail/u/0/?fs=1&tf=cm&to=chakrabortyk21offc@gmail.com",
  //   icon: gmail,
  // },
  { name: "Github", link: "https://github.com/ChakrabortyK", icon: github },
  {
    name: "Linkedin",
    link: "https://www.linkedin.com/in/chakrabortyk/",
    icon: linkedin,
  },
  {
    name: "HackerRank",
    link: "https://www.hackerrank.com/profile/chakrabortyk",
    icon: hackerrank,
  },
  {
    name: "LeetCode",
    link: "https://leetcode.com/u/KalpakChakraborty/",
    icon: leetcode,
  },
];

export const projects = [
  {
    title: "Movie Explorer",
    stack: "React Redux Thunk",
    description:
      "A project to implement Redux toolkit for react. In this project we are using an API to fetch details of all the movies and their reviews listed by IMDB.",
    image: movie,
    deployed: "https://chakrabortyk.github.io/movie-app-imdb/",
    github: "https://github.com/ChakrabortyK/movie-app-imdb",
  },
  {
    title: "React BlogPost",
    stack: "React Backend: Appwrite",
    description:
      "A React project to build a blog website with user login. Industry standard code and Appwrite service as a backend are used in the project.",
    image: reactblogapp,
    deployed: "https://cra-blog-app.vercel.app/",
    github: "https://github.com/ChakrabortyK/CRA-Blog-App",
  },
  {
    title: "ERP Dashboard",
    stack: "React and Redux",
    description:
      "A simplified interface for an ERP system designed to manage basic business operations efficiently. The application aims towards handling deletion and updation of data and their properties.",
    image: dashboard,
    deployed: "https://chakrabortyk.github.io/erp-dashboard/products",
    github: "https://github.com/ChakrabortyK/erp-dashboard",
  },
  {
    title: "React Todo App",
    stack: "React Hooks",
    description: "A react app to use react hooks and handle shange in states",
    image: todo,
    deployed: "https://chakrabortyk.github.io/Todo-React/",
    github: "https://github.com/ChakrabortyK/Todo-React",
  },
  {
    title: "React Text Utils",
    stack: "React",
    description:
      "First Project built for learning ReactJs which also implements switching of dark and light modes",
    image: reactTextUtils,
    deployed: "https://chakrabortyk.github.io/React-TextUtils/",
    github: "https://github.com/ChakrabortyK/React-TextUtils",
  },
];

export const testimonials = [
  {
    quote:
      "Lorem ipsum dolor sit amet consectetur adipisicing elit. Culpa quod necessitatibus quidem impedit facilis? Distinctio laboriosam veritatis recusandae minus. Voluptatum accusantium hic laudantium soluta ea sapiente cupiditate officia maiores itaque.",
    image: "https://randomuser.me/api/portraits/men/1.jpg",
    name: "Jesse Hicks",
    company: "Zoozle",
  },
  {
    quote:
      "Lorem ipsum dolor sit amet consectetur adipisicing elit. Culpa quod necessitatibus quidem impedit facilis? Distinctio laboriosam veritatis recusandae minus. Voluptatum accusantium hic laudantium soluta ea sapiente cupiditate officia maiores itaque.",
    image: "https://randomuser.me/api/portraits/men/94.jpg",
    name: "Ruben Alvarez",
    company: "Dooble.io",
  },
];

export const skills = [
  {
    name: "MongoDb",
    logo: mongodb,
  },
  {
    name: "SQL",
    logo: mysql,
  },

  {
    name: "ExpressJs",
    logo: express,
  },
  {
    name: "ReactJs",
    logo: react,
  },
  {
    name: "NodeJs",
    logo: nodejs,
  },
  {
    name: "Linux Shell",
    logo: linux,
  },
  {
    name: "JavaScript",
    logo: javascript,
  },
  {
    name: "Typescript",
    logo: typescript,
  },
  {
    name: "Core Java",
    logo: java,
  },
  {
    name: "Python",
    logo: python,
  },
  {
    name: "C/C++",
    logo: cpp,
  },
  {
    name: "Git, Github",
    logo: git,
  },
  {
    name: "Tailwind CSS",
    logo: tailwindcss,
  },

  {
    name: "BootStrap",
    logo: bootstrap,
  },
  {
    name: "Figma",
    logo: figma,
  },

  {
    name: "WordPress",
    logo: wordpress,
  },

  {
    name: "Google Ads",
    logo: ads,
  },
  // "JavaScript",
  // "NodeJs",
  // "MongoDb",
  // "WordPress",
  // "Tailwind",
  // "BootStrap",
  // "Core Java, C, C++",
  // "Git, Github",
];
